mutation UpdatePricelist($id: ID!, $pricelist: PricelistUpdateInput!) {
    updatePricelist(id: $id, pricelist: $pricelist) {
        id
        name(language: "en") { language text }
        currency
        countries
        defaultForCountries
        valid { from to }
        archived
    }
}
